import useReveal from "../hooks/useReveal";

/**
 * SEO-friendly long-form content block.
 * Visible to users (not hidden — that would be against Google's guidelines)
 * but visually understated so it doesn't distract from the marketing flow.
 * Heavy on natural keywords a hunting-game searcher would type.
 */
export default function SeoCopy() {
  const ref = useReveal();
  return (
    <section
      data-testid="seo-copy-section"
      aria-labelledby="seo-copy-heading"
      className="relative border-t border-white/5 bg-[#0a0d08]"
    >
      <div className="mx-auto max-w-5xl px-6 lg:px-10 py-20 lg:py-24">
        <div ref={ref} className="reveal">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-body">
            About the game
          </p>
          <h2
            id="seo-copy-heading"
            className="font-display mt-4 text-3xl sm:text-4xl text-white text-balance leading-[1.1]"
          >
            Sniper Hunter — a realistic 3D mobile hunting game by Volt Games.
          </h2>

          <div className="mt-8 space-y-5 text-[15px] text-white/65 font-body leading-relaxed max-w-3xl">
            <p>
              <strong className="text-white/90">Sniper Hunter</strong> is a
              premium 3D hunting simulator for Android, built by{" "}
              <a
                href="https://play.google.com/store/apps/developer?id=Volt+Games"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/85 underline decoration-white/20 hover:decoration-white/60"
              >
                Volt Games
              </a>
              . Pick your gun, load custom bullets, and step into the boots of a
              master hunter as you stalk wildlife across forests, mountains,
              savannas and lakes in stunning 3D environments.
            </p>
            <p>
              Track and hunt deer, elk, moose, cougar, white rhinoceros,
              grizzly bear, lion, timber wolf and more. Each animal reacts
              naturally to your presence — read the wind, hold your breath, and
              wait for the perfect shot to claim the ultimate trophy.
            </p>
            <p>
              Build an arsenal of meticulously rendered, real-world rifles such
              as the Savage 110, Springfield M1A, Remington 700, AWM and the
              Barrett M82, then pair them with signature ammunition like the
              Inferno tracer, Phantom spectral round and Leviathan deep-cold
              slug. Swap between first-person scope view and tactical
              third-person view at any time.
            </p>
            <p>
              Compete in rotating live-ops events — Weekend Challenge, Wild
              Race, Animal Collection and Sure Shot — and climb the global
              leaderboards in head-to-head PvP. Whether you call it a hunting
              game, sniper game, deer hunter, big game safari simulator or
              wildlife shooter, Sniper Hunter delivers the most realistic mobile
              hunt on Google Play.
            </p>
            <p className="text-white/55 text-sm">
              Free to download · Rated Teen (Violence, Blood) · Available on
              Android (Play Store) and Windows via Google Play Games.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
